/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserFlightDeleteRequest
 */
export interface UserFlightDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof UserFlightDeleteRequest
     */
    flightId: string;
}

/**
 * Check if a given object implements the UserFlightDeleteRequest interface.
 */
export function instanceOfUserFlightDeleteRequest(value: object): value is UserFlightDeleteRequest {
    if (!('flightId' in value) || value['flightId'] === undefined) return false;
    return true;
}

export function UserFlightDeleteRequestFromJSON(json: any): UserFlightDeleteRequest {
    return UserFlightDeleteRequestFromJSONTyped(json, false);
}

export function UserFlightDeleteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserFlightDeleteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'flightId': json['flight_id'],
    };
}

export function UserFlightDeleteRequestToJSON(json: any): UserFlightDeleteRequest {
    return UserFlightDeleteRequestToJSONTyped(json, false);
}

export function UserFlightDeleteRequestToJSONTyped(value?: UserFlightDeleteRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'flight_id': value['flightId'],
    };
}

